import React from 'react'
import Header from './layout/Header'
import copys from '../utils/copys'
import ErrorCard from '../components/ErrorCard'

const text = 'Estamos trabajando en la App para mejorar tu experiencia, por favor vuelve a intentar más tarde.';
const ScreenMaintenance = () => {
    return (
        <div className='flex flex-col items-center'>
            <Header isMaintenance />
            <div className="font-libre-franklin font-semibold text-xs text-blue_text pt-5 pb-1">
                {copys.homeSlogan}
            </div>
            <ErrorCard title='¡Volvemos pronto!' text={text} />
        </div>
    )
}

export default ScreenMaintenance
